<template>
  <div>
    <b-row class="my-5">
      <b-col class="mx-0 px-0">
        <b-form inline>
          <label class="pl-3" for="select1">ปี :</label
          ><b-form-select
            id="select1"
            class="ml-2 custom-select-filter"
            :options="optionYear"
            v-model="selectedYear"
            deselect-label="ยกเลิก"
            @input="filter"
          ></b-form-select>
        </b-form>
      </b-col>
      <b-col class="mx-0 px-0">
        <b-form inline>
          <label class="pl-3" for="select2">เดือน :</label
          ><b-form-select
            id="select2"
            class="ml-2 custom-select-filter"
            :options="optionMonth"
            v-model="selectedMonth"
            deselect-label="ยกเลิก"
            @input="filter"
          ></b-form-select>
        </b-form>
      </b-col>
      <b-col class="mx-0 px-0">
        <b-form inline>
          <label class="pl-3" for="select3">หมวดหมู่ :</label
          ><b-form-select
            id="select3"
            class="ml-2 custom-select-filter"
            :options="optionCate"
            v-model="selectedCate"
            deselect-label="ยกเลิก"
            @input="filter"
          ></b-form-select>
        </b-form>
      </b-col>
      <b-col cols="5"></b-col>
    </b-row>
    <div class="custom-grid">
      <div
        @click="details(x.id)"
        class="mx-4 px-0 on-hover-text"
        v-for="(x, i) in document"
        :key="i"
      >
        <img
          class="content-image pointer"
          :src="domain + '/' + x.image"
          alt=""
        /><br />
        <p style="text-align: left !important">{{ x.name }}</p>
      </div>
    </div>
    <b-row>
      <b-col offset="10">
        <b-button
          style="background: #db7f50; border-radius: 25px; border: 0"
          @click="$router.push('/documents')"
          class="w-100"
          >ดูเอกสารเพิ่มเติม >></b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { domain } from "@/utils/Constants";

export default {
  name: "document",
  components: {},
  props: {
    document: Array,
  },
  data() {
    return {
      optionYear: [{ value: "", text: "เลือกปี" }],
      optionMonth: [
        { value: "", text: "เลือกเดือน" },
        { value: "1", text: "มกราคม" },
        { value: "2", text: "กุมภาพันธ์" },
        { value: "3", text: "มีนาคม" },
        { value: "4", text: "เมษายน" },
        { value: "5", text: "พฤษภาคม" },
        { value: "6", text: "มิถุนายน" },
        { value: "7", text: "กรกฎาคม" },
        { value: "8", text: "สิงหาคม" },
        { value: "9", text: "กันยายน" },
        { value: "10", text: "ตุลาคม" },
        { value: "11", text: "พฤศจิกายน" },
        { value: "12", text: "ธันวาคม" },
      ],
      optionCate: [{ value: "", text: "เลือกหมวดหมู่" }],
      content: [],
      selectedYear: "",
      selectedMonth: "",
      selectedCate: "",
      domain: domain,
    };
  },
  created() {
    this.setFilter();
  },
  methods: {
    details(id) {
      this.$router.push(`/document/${id}`);
    },
    setFilter() {
      let self = this;
      const year = new Date().getFullYear() + 543;
      Array.from({ length: 10 }, (value, index) => {
        let arr = {
          value: year - index,
          text: year - index,
        };
        self.optionYear.push(arr);
      });
      this.$store.dispatch("dashboardModule/documentCategory").then((res) => {
        res.forEach((x) => {
          let arr = {
            value: x.id,
            text: x.name,
          };
          this.optionCate.push(arr);
        });
      });
    },
    filter() {
      let data = {
        year: this.selectedYear,
        month: this.selectedMonth,
        category: this.selectedCate,
        take: 5,
      };
      this.$store
        .dispatch("dashboardModule/documentIndex", data)
        .then((res) => {
          this.document = res;
        });
    },
  },
};
</script>

<style scoped>
.space-top {
  padding-top: 5px;
}
.content-image {
  width: 100%;
  height: auto;
}
.on-hover-text:hover {
  color: #db7f50;
}
.custom-select-filter {
  border-radius: 25px;
  border: 1px solid rgba(219, 127, 80, 1);
}
.custom-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 20%);
}
</style>
